const driverShifts = {
  filters: {
    suppliers: 'Fleets',
  },

  form: {
    information: {
      shiftDetails: {
        fields: {
          suppliers: 'Fleets',
        },
      },
    },
  },
  calendarTable: {
    filters: {
      suppliers: 'Fleets',
    },
  },
};

export default driverShifts;
